import React from "react";
import styled from "styled-components";
import { useDispatch } from "react-redux";
import { FrequencyInMonths } from "./Frequency";
import { SliderTitle } from "./SliderTitle";
import { UpdateFieldProps } from "src/store/Goal-Based/goal";
import { SegmentedControl } from "src/components/ui";

export enum Fields {
  period = "period",
  startDate = "start_date",
  endDate = "end_date",
  contributionType = "contribution_type",
  initialAmount = "initial_amount",
  contributionAmount = "contribution_amount",
  goalAmount = "goal_amount",
}

const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-start;
`;

/* Shortest first. The four are an ordered sequence — every month, every
   quarter, every half, every year — and that order is the only structure in
   the set, so it runs in it. */
const CADENCES = [
  { value: String(FrequencyInMonths.Monthly), label: "Monthly" },
  { value: String(FrequencyInMonths.Quarterly), label: "Quarterly" },
  { value: String(FrequencyInMonths.SemiAnnually), label: "Semi-annually" },
  { value: String(FrequencyInMonths.Annually), label: "Annually" },
];

/**
 * How often the contribution goes in.
 *
 * The product's segmented control, in place of four joined radio buttons
 * whose unselected state was accent text on an accent tint and whose
 * selected state was solid accent — so the row read as four buttons all
 * asking to be pressed, with the answer to "which is chosen" carried only by
 * a fill that was already the loudest thing in the field.
 *
 * The value crosses as a STRING and goes back as a number: the control is
 * generic over strings, and the API wants the cadence in months.
 */
export function FrequencyRadioField<T>(props: UpdateFieldProps<T>) {
  const dispatch = useDispatch();
  const { updateField, value } = props;

  return (
    <Field>
      <SliderTitle title="Frequency" />
      <SegmentedControl
        aria-label="Contribution frequency"
        size="sm"
        options={CADENCES}
        value={String(value)}
        onChange={(next) =>
          dispatch(
            updateField({
              name: Fields.contributionType,
              value: Number(next),
            }),
          )
        }
      />
    </Field>
  );
}
